/* INVOICES */
export const MAP_CANDIDATE = "MAP_CANDIDATE";
export const MAP_CANDIDATE_SUCCESS = "MAP_CANDIDATE_SUCCESS";
export const MAP_CANDIDATE_FAIL = "MAP_CANDIDATE_FAIL";

export const GET_MAPPED_CANDIDATE_DETAILS = "GET_MAPPED_CANDIDATE_DETAILS";
export const GET_MAPPED_CANDIDATE_DETAILS_SUCCESS =
  "GET_MAPPED_CANDIDATE_DETAILS_SUCCESS";
export const GET_MAPPED_CANDIDATE_DETAILS_FAIL =
  "GET_MAPPED_CANDIDATE_DETAILS_FAIL";

export const GET_MAPPED_CANDIDATES = "GET_MAPPED_CANDIDATES";
export const GET_MAPPED_CANDIDATES_SUCCESS = "GET_MAPPED_CANDIDATES_SUCCESS";
export const GET_MAPPED_CANDIDATES_FAIL = "GET_MAPPED_CANDIDATES_FAIL";

export const GET_MAPPED_CANDIDATES_COUNT = "GET_MAPPED_CANDIDATES_COUNT";
export const GET_MAPPED_CANDIDATES_COUNT_SUCCESS =
  "GET_MAPPED_CANDIDATES_COUNT_SUCCESS";
export const GET_MAPPED_CANDIDATES_COUNT_FAIL =
  "GET_MAPPED_CANDIDATES_COUNT_FAIL";

export const GET_CANDIDATE_STATUS = "GET_CANDIDATE_STATUS";
export const GET_CANDIDATE_STATUS_SUCCESS = "GET_CANDIDATE_STATUS_SUCCESS";
export const GET_CANDIDATE_STATUS_FAIL = "GET_CANDIDATE_STATUS_FAIL";

export const GET_CANDIDATE_ACTIVITY_FEED = "GET_CANDIDATE_ACTIVITY_FEED";
export const GET_CANDIDATE_ACTIVITY_FEED_SUCCESS =
  "GET_CANDIDATE_ACTIVITY_FEED_SUCCESS";
export const GET_CANDIDATE_ACTIVITY_FEED_FAIL =
  "GET_CANDIDATE_ACTIVITY_FEED_FAIL";
